<template>
  <div class="row">
    <RolledSection>
      <div slot="icon-beafore-title"><icon icon="drag-indicator" /></div>
      <div slot="header">
        Wariant {{ index + 1 }} -
        <span class="header--color"
          >id#{{ variant.id }} kod#{{ variant.index }}</span
        >
      </div>
      <div slot="button">
        <div
          class="button-icon button-icon--ml-10"
          @click="deleteVariant(index), $root.$emit('productIsChanged')"
        >
          <icon icon="trash" icon-classes="icon--grey button-icon--gray" />
        </div>
      </div>
      <div slot="body" class="row product-form--gray pb-4 mb-4">
        <RolledSection>
          <div slot="header">Zdjęcia</div>
          <div slot="body" class="row">
            <div class="col-24 col-xl-12">
              <Photos
                :photos="[variant.main_photo]"
                :multiplePhotos="false"
                :itemIndex="index"
                @delete="deletePhoto"
                folderPath="variants/main_photo/"
                labelName="Zdjęcie główne"
                @add="addPhoto"
                type="main_photo"
              ></Photos>
            </div>
            <div class="col-24">
              <Photos
                :photos="variant.packaging_photos"
                :multiplePhotos="true"
                :itemIndex="index"
                @delete="deletePhoto"
                folderPath="variants/packaging_photo/"
                labelName="Zdjęcie opakowania"
                type="packaging_photos"
              ></Photos>
            </div>
            <div class="col-24">
              <Photos
                :photos="variant.arrangement_photos"
                :multiplePhotos="true"
                :itemIndex="index"
                @delete="deletePhoto"
                folderPath="variants/arrangement_photo/"
                labelName="Zdjęcie aranżacji"
                type="arrangement_photos"
              ></Photos>
            </div>
            <div class="col-24 mb-4">
              <Photos
                :photos="variant.gallery"
                :multiplePhotos="true"
                :itemIndex="index"
                folderPath="variants/gallery/"
                @delete="deletePhoto"
                labelName="Galeria"
                type="gallery"
              ></Photos>
            </div>
            <div class="col-24">
              <TextareaSimple
                label="Kod zdjęcia 360"
                fieldName="photo_360"
                :object="variant"
              ></TextareaSimple>
            </div></div
        ></RolledSection>
        <RolledSection>
          <div slot="header">Informacje podstatowe</div>
          <div slot="body" class="row">
            <div class="col-24 col-xl-8">
              <InputSimple
                :object="variant"
                label="Kod wariantu*"
                fieldName="index"
                type="text"
              ></InputSimple>
            </div>
            <div class="col-24 col-xl-8">
              <InputSimple
                :object="variant"
                label="Kod EAN-13*"
                fieldName="ean13"
                type="text"
              ></InputSimple>
            </div>
            <div class="col-24 col-xl-8">
              <InputSimple
                :object="variant"
                label="Nazwa*"
                fieldName="name"
                type="text"
              ></InputSimple>
            </div>
            <div class="col-24 col-xl-8">
              <Checkbox
                :object="variant"
                label="Status"
                fieldName="is_acctive"
              ></Checkbox>
            </div>
            <div class="col-24 col-xl-8">
              <Checkbox
                :object="variant"
                label="Nowość"
                fieldName="is_new"
              ></Checkbox>
            </div>
            <div class="col-24 col-xl-8">
              <Checkbox
                :object="variant"
                label="Występuje w zestawie"
                fieldName="is_included_in_set"
              ></Checkbox>
            </div>
            <div class="col-24 col-xl-8">
              <Checkbox
                :object="variant"
                label="Kolor uniwersalny"
                fieldName="universal_color"
              ></Checkbox>
            </div>
          </div>
        </RolledSection>
        <RolledSection>
          <div slot="header">Dane logistyczne</div>
          <div slot="body">
            <LogisticsData
              :logisticsData="
                variant.logistics_data ? variant.logistics_data : {}
              "
              :dictionaries="dictionaries"
            />
          </div>
        </RolledSection>
        <SetProducts
          :setProducts="variant.set_products"
          @addProduct="addSetProduct"
          @deleteProduct="deleteSetProduct"
          type="similar"
          title="Produkty w zestawie"
        ></SetProducts>
        <RolledSection>
          <div slot="header">Lista atrybutów</div>
          <div slot="body">
            <div class="col-24" v-if="variant.attributes.length">
              <table class="items-table">
                <thead>
                  <tr class="items-table__tr">
                    <th class="items-table__th">nazwa</th>
                    <th class="items-table__th items-table__th--w30">
                      wartość
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <VariantItemAttribute
                    v-for="(attribute, indexAttribute) in variant.attributes"
                    :key="attribute.id"
                    :attribute="attribute"
                    :index="indexAttribute"
                    :index-variant="index"
                    @set-new-attribute="setNewAttribute"
                  >
                  </VariantItemAttribute>
                </tbody>
              </table>
            </div>
            <div class="col-24" v-else>
              Brak dostępnych atrybutów w tej kategorii
            </div>
          </div></RolledSection
        >
      </div>
    </RolledSection>
  </div>
</template>
<script>
import Icon from "../parts/Icon";
import Photos from "./Photos";
import SetProducts from "./SetProducts.vue";

import InputSimple from "./forms/InputSimple.vue";
import Checkbox from "./forms/Checkbox.vue";
import RolledSection from "./forms/RolledSection.vue";
import VariantItemAttribute from "./VariantItemAttribute.vue";
import LogisticsData from "./LogisticsData.vue";
import TextareaSimple from "./forms/TextareaSimple.vue";

export default {
  data() {
    return {
      isLoading: false,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
      units: [
        {
          id: "mm",
          name: "mm",
        },
        {
          id: "cm",
          name: "cm",
        },
        {
          id: "m",
          name: "m",
        },
      ],
    };
  },
  props: {
    variant: {
      type: Object,
      required: false,
    },
    index: {
      type: Number,
      require: false,
    },
    dictionaries: {
      type: Object,
      required: true,
    },
  },
  components: {
    Icon,
    Photos,
    TextareaSimple,
    SetProducts,
    LogisticsData,
    InputSimple,
    Checkbox,
    RolledSection,
    VariantItemAttribute,
  },
  mounted() {
    this.$root.$on("saveProduct", () => {
      this.storeProduct();
    });
  },
  beforeDestroy() {
    this.$root.$off("saveProduct");
  },
  methods: {
    addPhoto(photo, itemIndex, type) {
      this.variant[type] = photo;
    },
    deletePhoto(photo, itemIndex, type) {
      if (
        type == "gallery" ||
        type == "packaging_photos" ||
        type == "arrangement_photos"
      ) {
        const filtersList = this.variant[type].filter(
          (element) => element !== photo
        );
        this.variant[type] = filtersList;
      } else {
        this.variant[type] = {
          id: null,
          path: null,
          type: type,
        };
      }
    },
    deleteVariant(index) {
      this.$emit("deleteVariant", index);
    },
    addSetProduct(chosenProduct) {
      this.variant.set_products.push({
        product_id: chosenProduct.product_id,
        product_index: chosenProduct.product_index,
        product_name: chosenProduct.product_name,
        variant_id: chosenProduct.variant_id,
        variant_index: chosenProduct.variant_index,
        variant_name: chosenProduct.variant_name,
      });
    },
    deleteSetProduct(chosenProduct) {
      const filtersList = this.variant.set_products.filter(function (element) {
        return !(
          element.product_id === chosenProduct.product_id &&
          element.variant_id === chosenProduct.variant_id
        );
      });
      this.variant.set_products = filtersList;
    },
    setNewAttribute(attribute, index) {
      this.$set(this.variant.attributes, index, attribute);
    },
  },
};
</script>
